'use strict';

angular.module('formonlineApp')
    .config(function ($stateProvider) {
        $stateProvider.state('calculis', {
            parent: 'fullwidth',
            url: '/calculis/{locale}',
            views: {
                'content@': {
                    templateUrl: 'scripts/app/form/calculis/calculis.html',
                    controller: 'CalculetteController'
                }
            }
        });
    });
